import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import componentUtils from '../../../lib/componentUtils';
import Link from '../../Link/Link';

import '../form.css';

class InputField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inputValue: props.defaultValue || '',
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    const { onChange } = this.props;
    this.setState({
      inputValue: e.target.value,
    });
    if (onChange && typeof onChange === 'function') {
      onChange(e);
    }
  }

  render() {
    const {
      label,
      labelClass,
      helperText,
      type,
      id,
      required,
      placeholder,
      disabled,
      onBlurFunction,
      className,
      autoFocus,
      onKeyDown,
      pattern,
      defaultValue,
      errorMessage,
      maxChars,
      name,
      addOn,
      onCopyLink,
    } = this.props;
    const { inputValue } = this.state;

    // eslint-disable-next-line react/forbid-foreign-prop-types
    const rest = componentUtils.getUnusedProps(this.constructor.propTypes, this.props);

    return (
      <div
        className={classNames(
          'zola-ui render-field',
          { 'has-error': errorMessage },
          { 'has-add-on': addOn },
          className
        )}
      >
        {label && (
          <label htmlFor={id} className={labelClass}>
            {label}
            {required && <span className="text-danger danger-asterisk">*</span>}
          </label>
        )}
        <div className="input-field__container">
          {addOn && (
            <div className="input-addon">
              <div className="input-addon-icon">{addOn}</div>
            </div>
          )}
          <input
            {...rest}
            name={name}
            className="input-field"
            defaultValue={defaultValue}
            type={type}
            id={id}
            placeholder={placeholder}
            disabled={disabled}
            autoFocus={autoFocus}
            onBlur={(e) => {
              if (onBlurFunction && e) {
                onBlurFunction(e.target.value);
              }
            }}
            onKeyDown={onKeyDown}
            pattern={pattern}
            onChange={this.handleChange}
          />
          {onCopyLink && (
            <Link onClick={onCopyLink} size="lg" className="copy-link-cta copy-link-cta__desktop">
              Copy Link
            </Link>
          )}
          {onCopyLink && (
            <Link onClick={onCopyLink} className="copy-link-cta copy-link-cta__mobile">
              <i onClick={onCopyLink} className="zola-ui-icon zola-ui-icon-link" />
            </Link>
          )}
          {maxChars && (
            <span
              className={classNames(
                'help-block max-characters-block',
                { 'text-danger': inputValue.length > maxChars },
                { hidden: inputValue.length <= maxChars }
              )}
            >
              You are {inputValue.length - maxChars} characters over maximum.
            </span>
          )}
          {errorMessage && <span className="help-block text-danger">{errorMessage}</span>}
        </div>
        {maxChars && (
          <div className="secondary-help-block max-characters-block">
            <span>Maximum {maxChars} characters</span>
            <span>
              {inputValue.length}/{maxChars}
            </span>
          </div>
        )}
        {helperText && (
          <div className="secondary-help-block max-characters-block">{helperText}</div>
        )}
      </div>
    );
  }
}

InputField.propTypes = {
  defaultValue: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  labelClass: PropTypes.string,
  helperText: PropTypes.string,
  type: PropTypes.oneOf([
    'text',
    'email',
    'password',
    'tel',
    'number',
    'url',
    'search',
    'date',
    'time',
  ]).isRequired,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  onBlurFunction: PropTypes.func,
  className: PropTypes.string,
  name: PropTypes.string,
  errorMessage: PropTypes.string,
  autoFocus: PropTypes.bool,
  onKeyDown: PropTypes.func,
  pattern: PropTypes.string,
  maxChars: PropTypes.number,
  addOn: PropTypes.string,
  onCopyLink: PropTypes.func,
  onChange: PropTypes.func,
};

export default InputField;
